<!-- 空白页面 -->
<template>
  <div class="zlr-empty">
    <div class="zlr-empty-con">
      <img :src="magnifier"
           alt="">
      <span>Empty page, no result, try doing something</span>
    </div>
  </div>
</template>

<script>
// less
import './empty.less'
// images
import magnifier from '@/assets/images/empty/magnifier.svg'
export default {
  name: '',
  components: {},
  data () {
    return {
      magnifier
    };
  },
  computed: {},
  mounted () { },
  methods: {}
}
</script>
<style lang='less' scoped>
</style>